// extracted by mini-css-extract-plugin
module.exports = {"sliderCircle":"Zy7Ma","sliderSquare":"te27s"};